<template>
  <card>
    <language-list v-if="$store.state.user.is_root" v-model="params['locale']" :isAll="true"
      @input="params['page'] = 1" />
    <list v-if="$store.state.user.is_root" :columns="columns" :modalCreate="modalCreate" :removeLink="removeLink"
      :cardLink="cardLink" :isUpdate="true" :isAdd="true" :itemLink="itemLink" :params="params" :setLink="setLink"
      :filters="filters" :openItem="true" :fields="fields" :searchDisable="false" @change="change"
      @changeFunction="changeFunction" v-model="val" />
  </card>
</template>
<script>
export default {
  name: "products",
  methods: {
    changeFunction(val) { },
    change(val) { },
  },
  data() {
    return {
      val: [],
      params: {},
      modalCreate: "lessonplan",

      filters: [
        {
          key: "course",
          title: "Номер Класса",
        },
        {
          key: "discipline",
          title: "Дисциплина",
        },

      ],

      fields: [
        {
          col: 'col-12 col-md-4',
          key: "position",
          label: "Номер темы",
          type: "field",
          textType: "number",
        },
        {
          col: 'col-12 col-md-8',
          key: "name",
          label: "Название темы",
          type: "field",
          textType: "text",
        },

        {
          label: "Предмет",
          key: "discipline",
          type: "select",
          selectKey: "title",
          modal: "discipline",
          prefix: "discipline_lessonplan",

        },
        {
          col: 'col-12 col-md-6',
          key: "locale",
          label: "Локализация контента",
          type: "locale",
          textType: "text",
        },
        {
          col: 'col-12 col-md-6',
          label: "Для классов",
          key: "course_id",
          type: "course",

        },


      ],
      /** APIs */
      removeLink: "",
      cardLink: "item_lessonplan",
      itemLink: "lessonplans",
      setLink: "lessonplans",
      columns: [
        {
          key: "position",
          title: "Номер темы",
          checkbox: false,
          inputSet: true,
          sortBy: 'position'
        },
        {
          key: "name",
          title: "Название темы",
          checkbox: false,
          control: false,
          align: "left",
          timer: false,
          detail: false,
        },
        {
          key: "locale",
          title: "Язык",
          checkbox: false,
          control: false,
          align: "left",
          timer: false,
          detail: false,
        },
        {
          key: "discipline",
          title: "Предмет",
          checkbox: false,
          control: false,
          align: "left",
          timer: false,
          detail: false,
          object: "title",
        },
        {
          key: "course",
          object: "title",
          title: "Класс",
          checkbox: false,
          full: false,
          control: false,
          disableLink: true,
          align: "left",
          timer: false,
          detail: false,
        },
        {
          key: "created_at",
          title: "Создан",
          sortBy: 'created_at',
          dateTimeFormat: true,
        },
        {
          detail: true,
          remove: true,
        },
      ],
    };
  },
};
</script>
<style>
</style>
